import { create } from 'zustand';
import { DEFAULT_MODEL_ID, type AssistantModelId } from '@/lib/assistant/models';
// DEFAULT_MODEL_ID is now 'auto' — Nula picks the best model with fallback

// ── UI-only state ────────────────────────────────────────────────────────────
// The heavy run-tracking state (AgentRun, AgentEvent, liveStreams, etc.) was
// removed in M12b. The new assistant consumers drive message state via
// Vercel SDK v6's useChat (through useAssistantChat + AssistantTransport).
// The store now holds only the two cross-consumer UI preferences that need to
// persist while the assistant is open/closed.

type AssistantStoreState = {
  /** Pinned context doc IDs — shared across panel and sidebar, persists open/close */
  contextDocIds: string[];
  setContextDocIds: (ids: string[]) => void;
  /** Selected AI model — shared across panel and sidebar, persists open/close */
  selectedModel: AssistantModelId;
  setSelectedModel: (id: AssistantModelId) => void;
  // The conversation currently rendered in the chat view moved to the
  // connection-scoped registry store (features/assistant/stores/
  // use-conversation-registry-store.ts) — it is a derived view of the registry
  // map, not a standalone scalar.
};

export const useAssistantStore = create<AssistantStoreState>((set) => ({
  contextDocIds: [],
  setContextDocIds: (ids) => set({ contextDocIds: ids }),
  selectedModel: DEFAULT_MODEL_ID,
  setSelectedModel: (id) => set({ selectedModel: id }),
}));
